<a class="half-circle-btn" routerLink="{{link}}">
  <p class="jubla-font">{{title}}</p>
</a>
